import gql from 'graphql-tag';

const UGLIFYJS = gql`
  query uglifyJS($jscode: String!) {
    uglifyJS(jscode: $jscode)
  }
`;

export default UGLIFYJS;
